module.exports = __webpack_public_path__ + "static/assets/55f1b7539495f2bd422dbc5a48b2b11f.svg";